export default __webpack_public_path__ + "static/media/otp-sent.5e221a40.png";